import { render, staticRenderFns } from "./PaginaCostoProduzioni.vue?vue&type=template&id=7c6af056"
import script from "./PaginaCostoProduzioni.vue?vue&type=script&lang=js"
export * from "./PaginaCostoProduzioni.vue?vue&type=script&lang=js"
import style0 from "./PaginaCostoProduzioni.vue?vue&type=style&index=0&id=7c6af056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports